import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import styled from "styled-components";
export var WhiteBackground = styled(Column).withConfig({
    componentId: "sc-80960810-0"
})([
    "background:",
    ";"
], Core.surface.inverse);
